<nav class="navbar navbar-expand-lg header-container" [ngClass]="{ home: isHome }">
    <div class="menu-logo d-flex align-items-center">
        <img routerLink="home" [src]="'assets/images/STC_logo.svg'" class="stc-logo" />
    </div>
    <button
        (click)="toggleDisplayDivIf()"
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarResponsive"
        aria-controls="navbarResponsive"
        aria-expanded="false"
        aria-label="Toggle navigation"
    >
        <span class="navbar-dark navbar-toggler-icon"></span>
    </button>
    <div
        [ngClass]="!isShowDivIf ? 'responsive__active' : 'responsive__inactive'"
        id="divNav"
        class="collapse navbar-collapse menu-wrapper"
        id="navbarResponsive"
    >
        <ul class="menu-list navbar-nav ml-auto">
            <div [ngClass]="!isShowDivIf ? 'showopennav' : 'hideopennav'" class="stsInfo">
                <li class="menu-item user closeicon brnone" (click)="toggleDisplayDivIf()">
                    <div><i class="fa fa-close"></i></div>
                </li>
                <li class="menu-item user brnone" [ngClass]="{ welUser: userRole === userRoleEmpolyee }">
                    <img class="user-image" [src]="loggedInUserDetails.image" onerror="this.src='assets/images/user2.jpg'" />

                    <div class="info user-info">
                        <span class="welcome-message">{{ 'welcome' | translate }}</span>
                        <p class="user-name">{{ loggedInUserDetails | getValueByLang }}</p>
                        <p class="user-role">{{ userRoleName }}</p>
                    </div>
                </li>
                <li class="menu-item user brnone" *ngIf="userRole === userRoleEmpolyee">
                    <div class="divStatus">
                        <span> {{ 'status' | translate }}</span>
                        <span [ngClass]="{ checked: checked === true, unchecked: checked === false }">{{ statusText | translate }}</span>
                        <mat-slide-toggle (change)="change($event)" [checked]="checked"></mat-slide-toggle>
                    </div>
                </li>
            </div>
            <li [routerLink]="[menu.path]" routerLinkActive="active-menu-item" class="menu-item" *ngFor="let menu of menuList" (click)="onMenuClick(menu)">
                {{ menu.name | translate }}
            </li>
        </ul>
        <div class="menu-actions">
            <ul class="menu-list lang-logout">
                <li class="change-lang" *ngIf="otherLang$ | async as otherLang">
                    <button type="button" class="toggle-lang btn btn-outline-primary" (click)="switchLang(otherLang)">
                        {{ otherLang }}
                    </button>
                </li>
                <div [ngClass]="isShowDivIf ? 'showopennav' : 'hideopennav'" class="stsInfo">
                    <li class="menu-item user" [ngClass]="{ welUser: userRole === userRoleEmpolyee }">
                        <img class="user-image" [src]="loggedInUserDetails.image" onerror="this.src='assets/images/user2.jpg'" />

                        <div class="info">
                            <span>{{ 'welcome' | translate }}</span>
                            <p>{{ loggedInUserDetails | getValueByLang }}</p>
                        </div>
                    </li>
                    <li class="menu-item user brnone" *ngIf="userRole === userRoleEmpolyee">
                        <div class="divStatus">
                            <span> {{ 'status' | translate }}</span>
                            <span [ngClass]="{ checked: checked === true, unchecked: checked === false }">{{ statusText | translate }}</span>
                            <mat-slide-toggle (change)="change($event)" [checked]="checked"></mat-slide-toggle>
                        </div>
                    </li>
                </div>
                <li class="menu-item" *ngIf="!isWebView">
                    <button class="btn coral-text" (click)="onLogout()">{{ 'logout' | translate }}</button>
                </li>
            </ul>
        </div>
    </div>
</nav>
